import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import { apiClient } from './services/apiClient'
// Bootstrap CSS is loaded via index.html to ensure proper style ordering
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './assets/styles/global.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Set up router in apiClient for invalid session handling
apiClient.setRouter(router)

app.mount('#app')